import * as consts from './ClaimHomeConsts';

const initialState = {
    data: null,
    isPending: false,
    url: '',
    error: ''
}

const claimHome = (state = initialState, action) => {
    switch (action.type) {

    case consts.GET_CLAIM_HOME_DATA_PENDING:
        return {
            ...state,
            isPending: true
        }
    case consts.GET_CLAIM_HOME_DATA_FULFILLED:
        return {
            ...state,
            isPending: false,
            data: action.payload
        }
    case consts.GET_CLAIM_HOME_DATA_REJECTED:
        return {
            ...state,
            isPending: false,
            data: null,
            error: action.payload
        }

    default:
        return state
  }
}

export default claimHome;
